import { html, nothing } from 'lit';
import { unsafeHTML } from 'lit-html/directives/unsafe-html.js';
import componentStyles from './cta-image-fullwidth.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';
import { classMap } from "lit-html/directives/class-map";

/**
 * Call to Action image card. Regular and Homepage variant.
 *
 * @element hf-cta-image-fullwidth
 */
export default class CtaImageFullWidth extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      /**
       * Main content area title
       */
      title: { type: String },
      /**
       * Main content area text below title
       */
      alertText: { type: String },
    };
  }

  render() {
    let title = html`<h1 class=" heading style--cta-image ">
              ${unsafeHTML(this.title)}
            </h1>`;

    return html`
      <div
        class="${classMap({
      'cta-image': true,
    })}"
      >
        <div class="cta-image__wrapper--full-width">
          <div class="cta-image__alert-text">
            <p>${unsafeHTML(this.alertText)}</p>
          </div>
          <div class="cta-image__image">
            <hf-responsive-image
              imageStyle="cta-image"
            >
              <div slot="image">
                <slot name="image"></slot>
              </div>
            </hf-responsive-image>
          </div>
          <div class="cta-image__content">
            ${title}
          </div>
        </div>
      </div>
    `;
  }
}

customElements.define('hf-cta-image-fullwidth', CtaImageFullWidth);
